import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "@/store";

interface WelcomeSectionProps {
  description?: string;
}

const WelcomeSection: React.FC<WelcomeSectionProps> = ({ description }) => {
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.user);

  const displayDescription = description || t("onboarding.intro.description");

  return (
    <div className="mb-6">
      <h2 className="text-[18px] mb-6">
        {t("onboarding.intro.welcome_title", { name: user.firstname })}
      </h2>
      <p className="mb-6">{displayDescription}</p>
    </div>
  );
};

export default WelcomeSection;
